module.exports = __webpack_public_path__ + "static/img/5971_phase_function_Paper_PointsHejduk_Prediction.85713d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5971_phase_function_Paper_PointsHejduk_Prediction.png
// module id = LSmm
// module chunks = 0